import {
  Store,
  createStore,
  combineReducers,
  compose,
  applyMiddleware
} from 'redux';

import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { AppState, reducers } from '../reducers';

// authentication
// oidc middleware removed in favor of context-based auth

export const configureStore = (
  history: History,
  initialState?: Partial<AppState>
): Store<AppState> => {
  const middleware = [thunk, routerMiddleware(history)];

  

  const rootReducer = combineReducers<AppState>({
    ...(reducers as unknown as AppState),
    router: connectRouter(history) as any
  } as any);

  const windowIfDefined =
    typeof window === 'undefined' ? null : (window as any);
  
  // Configuración mejorada de Redux DevTools
  const composeEnhancers =
    windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? windowIfDefined.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Opciones para Redux DevTools
          trace: true, // Habilita el seguimiento de acciones
          traceLimit: 25, // Límite de seguimiento
          actionsBlacklist: [], // No filtrar ninguna acción
          actionsSanitizer: (action: any) => action, // No sanitizar acciones
          stateSanitizer: (state: any) => state, // No sanitizar estado
          maxAge: 50, // Mantener las últimas 50 acciones
        })
      : compose;

  const store = createStore<AppState, any, any, any>(
    rootReducer as any,
    (initialState as Partial<AppState>) as any,
    composeEnhancers(applyMiddleware(...middleware))
  );
  
  return store;
};
